import { getCursor } from '@spazious/dollhouse-selector';

import { MigrationStateV2_0_0 } from './migration-v2.0.0.js';
import { Migration, MigrationVersionEnum } from './types.js';

export type MigrationStateV3_0_0 = {
  version: string;
  cursor: string | null;
  nodes: {
    [selector: string]: {
      type: number;
      id: number;
      attrs?: Record<string, any>;
      meta?: Record<string, any>;
    };
  };
};

export const migration_3_0_0: Migration<
  MigrationVersionEnum.v3_0_0,
  MigrationStateV2_0_0,
  MigrationStateV3_0_0
> = {
  version: MigrationVersionEnum.v3_0_0,
  check: (state) => Array.isArray(state),
  migrate: (state) => {
    let cursor: string | null = null;
    const nodes = Object.fromEntries(
      state.map(({ selector, ...restNode }) => {
        cursor = getCursor(selector, cursor);
        return [selector, restNode];
      })
    ) as MigrationStateV3_0_0['nodes'];
    return {
      version: MigrationVersionEnum.v3_0_0,
      cursor,
      nodes,
    };
  },
};
